import { hospitalOrNursingHomeValue } from './forms/form-values';

/**
 * The facility catalogue's `value.type` exists in two shapes in stored data:
 * the canonical option object ({ name: 'Hospital', value: 'hospital' }) written
 * by the facility modals/imports, and a handful of legacy plain strings
 * ('hospital' / 'nursing-home') from early bulk loads. Readers that assumed the
 * object shape rendered the legacy rows as untyped (blank Type column, facility
 * missing from the arrangement facility dropdowns, blank type select in the
 * details modal). These helpers accept both shapes; a data migration normalises
 * the stored stragglers to the object shape.
 */
export function facilityTypeValue(type: any): string | null {
  if (!type) {
    return null;
  }
  if (typeof type === 'string') {
    return type;
  }
  return typeof type.value === 'string' ? type.value : null;
}

/**
 * Resolve any stored type shape to the canonical option object (the instance
 * from hospitalOrNursingHomeValue where possible, so dropdowns match it).
 * Returns null when there's no usable type.
 */
export function facilityTypeOption(type: any): { name: string; value: string } | null {
  const value = facilityTypeValue(type);
  if (!value) {
    return null;
  }
  return (
    hospitalOrNursingHomeValue.find((option) => option.value === value) || {
      name: value,
      value,
    }
  );
}
